import type { RouteObject } from "react-router";
import { createElement } from "react";
import { ArbitrationQueuePage } from "./ArbitrationQueuePage";
import { ArbitrationPage } from "./ArbitrationPage";

/** docs/UX.md 9–10. Mounted by `router.tsx` behind `RequireRole adjudicator`. */
export const routes: RouteObject[] = [
  { path: "/j", element: createElement(ArbitrationQueuePage) },
  { path: "/j/:recordingId", element: createElement(ArbitrationPage) },
];

export { arbitrationHref } from "./ArbitrationQueuePage";
export { ArbitrationQueuePage, ArbitrationPage };
